// extracted by mini-css-extract-plugin
export var cmtTab = "styles-module--cmt-tab--f81a8";
export var cmtTabDefault = "styles-module--cmt-tab--default--f99b5";
export var cmtTabDisabled = "styles-module--cmt-tab--disabled--c6fc4";
export var cmtTabMinimal = "styles-module--cmt-tab--minimal--bcf18";
export var cmtTabOverflow = "styles-module--cmt-tab--overflow--97965";
export var cmtTabSelected = "styles-module--cmt-tab--selected--ebd28";
export var cmtTab__label = "styles-module--cmt-tab__label--9862c";